module.exports = __webpack_public_path__ + "img/delete_4.00f1eb80.jpg";